/**
 * Terminbuchung im Calendly-Stil (Shopify-Section „terminbuchung“).
 * Ablauf: Terminart → Tag und Uhrzeit → Angaben → Bestätigung. Mit ?absage=<token>: Absage.
 * Direktlink auf eine Terminart: ?art=telefon bzw. ?art=praesenz
 */
(function () {
  'use strict';

  const WOCHENTAGE = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  const MONATE = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  const KOPF = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];

  const ICON = {
    uhr: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
    telefon: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2"/></svg>',
    ort: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7-6.2-7-11.5a7 7 0 0 1 14 0C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/></svg>',
    kalender: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/></svg>',
    welt: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"/></svg>',
    zurueck: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>',
    links: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>',
    rechts: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>',
    haken: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
  };

  const ARTEN = {
    telefon: {
      titel: 'Telefontermin',
      dauer: '60 Min.',
      icon: ICON.telefon,
      ortText: 'Telefon oder Videokonferenz',
      text: 'Persönliche Beratung am Telefon – auf Wunsch auch per Videokonferenz.',
    },
    praesenz: {
      titel: 'Präsenztermin',
      dauer: '2 Std.',
      icon: ICON.ort,
      ortText: 'Bei Ihnen vor Ort oder in unserem Büro',
      text: 'Beratung und/oder Aufmaß bei Ihnen vor Ort oder in unserem Büro.',
    },
  };

  // ---------- Hilfen ----------

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function teile(datum) {
    return datum.split('-').map(Number);
  }

  function wochentagIndex(datum) {
    const [j, m, t] = teile(datum);
    return new Date(Date.UTC(j, m - 1, t)).getUTCDay();
  }

  function datumLang(datum, mitJahr) {
    const [j, m, t] = teile(datum);
    return WOCHENTAGE[wochentagIndex(datum)] + ', ' + t + '. ' + MONATE[m - 1] + (mitJahr ? ' ' + j : '');
  }

  function plusMinuten(zeit, min) {
    const ges = Number(zeit.slice(0, 2)) * 60 + Number(zeit.slice(3, 5)) + min;
    return String(Math.floor(ges / 60)).padStart(2, '0') + ':' + String(ges % 60).padStart(2, '0');
  }

  function monatPlus(monat, n) {
    const [j, m] = monat.split('-').map(Number);
    const d = new Date(Date.UTC(j, m - 1 + n, 1));
    return d.toISOString().slice(0, 7);
  }

  // ---------- Backend ----------

  function backend(root) {
    if (window.TB_MOCK) return window.TB_MOCK;
    const url = root.getAttribute('data-backend');
    const fehler = { ok: false, fehler: 'Keine Verbindung zum Terminsystem. Bitte versuchen Sie es später erneut oder rufen Sie uns an.' };
    const json = (r) => r.json();
    return {
      get(params) {
        return fetch(url + '?' + new URLSearchParams(params).toString()).then(json).catch(() => fehler);
      },
      post(daten) {
        // text/plain (Standard bei String-Body) vermeidet einen CORS-Preflight, den Apps Script nicht beantwortet
        return fetch(url, { method: 'POST', body: JSON.stringify(daten) }).then(json).catch(() => fehler);
      },
    };
  }

  // ---------- Buchung ----------

  function init(root) {
    const api = backend(root);
    const datenschutz = root.getAttribute('data-datenschutz') || '/policies/privacy-policy';
    const params = new URLSearchParams(location.search);

    if (params.get('absage')) {
      absage(root, api, params.get('absage'));
      return;
    }

    const s = {
      schritt: 'art',
      art: null,
      monat: null,
      tag: null,
      zeit: null,
      eingaben: { kanal: 'telefon', ort: 'kunde' },
      fehler: '',
      senden: false,
      ergebnis: null,
    };
    const slots = {};
    const ladeSlots = (art) => (slots[art] = api.get({ action: 'slots', art }));
    Object.keys(ARTEN).forEach(ladeSlots); // vorab laden, damit der Kalender sofort da ist

    function gehe(schritt) {
      s.schritt = schritt;
      s.fehler = '';
      render();
      const oben = root.getBoundingClientRect().top;
      if (oben < 0) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function waehleArt(art) {
      s.art = art;
      s.tag = null;
      s.zeit = null;
      s.daten = null;
      gehe('zeit');
      slots[art].then((d) => {
        if (s.art !== art) return;
        if (!d.ok) {
          s.fehler = d.fehler;
          s.daten = { tage: {} };
        } else {
          s.daten = d;
          const erster = Object.keys(d.tage)[0];
          s.monat = (erster || d.von).slice(0, 7);
        }
        render();
      });
    }

    // --- Ansichten ---

    function seite(mitTermin) {
      const a = ARTEN[s.art];
      const dauerMin = s.daten && s.daten.dauer;
      return (
        '<div class="tb-seite">' +
        '<button type="button" class="tb-zurueck" data-aktion="zurueck" aria-label="Zurück">' + ICON.zurueck + '</button>' +
        '<h2 class="tb-titel">' + esc(a.titel) + '</h2>' +
        '<ul class="tb-meta">' +
        '<li>' + ICON.uhr + esc(a.dauer) + '</li>' +
        '<li>' + a.icon + esc(a.ortText) + '</li>' +
        (mitTermin && dauerMin
          ? '<li class="tb-meta-termin">' + ICON.kalender + esc(s.zeit + ' – ' + plusMinuten(s.zeit, dauerMin) + ', ' + datumLang(s.tag, true)) + '</li>' +
            '<li>' + ICON.welt + 'Mitteleuropäische Zeit</li>'
          : '') +
        '</ul>' +
        (mitTermin ? '' : '<p class="tb-beschreibung">' + esc(a.text) + '</p>') +
        '</div>'
      );
    }

    function fehlerBox() {
      return s.fehler ? '<p class="tb-fehler" role="alert">' + esc(s.fehler) + '</p>' : '';
    }

    function ansichtArt() {
      return (
        '<div class="tb-karte tb-karte--start">' +
        '<div class="tb-start-kopf">' +
        '<h2 class="tb-titel">' + esc(root.getAttribute('data-ueberschrift') || 'Termin vereinbaren') + '</h2>' +
        '<p class="tb-beschreibung">' + esc(root.getAttribute('data-einleitung') || 'Wählen Sie die passende Terminart und buchen Sie direkt einen freien Termin mit unserem Tischlermeister Patrick Henseler.') + '</p>' +
        '</div>' +
        '<div class="tb-arten">' +
        Object.keys(ARTEN).map((k) => {
          const a = ARTEN[k];
          return (
            '<button type="button" class="tb-art" data-aktion="art" data-wert="' + k + '">' +
            '<span class="tb-art-icon">' + a.icon + '</span>' +
            '<span class="tb-art-text"><strong>' + esc(a.titel) + '</strong>' +
            '<span class="tb-art-dauer">' + ICON.uhr + esc(a.dauer) + '</span>' +
            '<span class="tb-art-beschreibung">' + esc(a.text) + '</span></span>' +
            '<span class="tb-art-pfeil">' + ICON.rechts + '</span>' +
            '</button>'
          );
        }).join('') +
        '</div></div>'
      );
    }

    function kalender() {
      const d = s.daten;
      if (!d) return '<div class="tb-laden" role="status"><span class="tb-spinner"></span>Freie Termine werden geladen …</div>';
      if (!Object.keys(d.tage).length && !s.fehler) {
        return '<p class="tb-hinweis">Aktuell sind keine Termine frei. Bitte rufen Sie uns an.</p>';
      }
      if (!d.von) return '';
      const [j, m] = s.monat.split('-').map(Number);
      const ersterWt = (new Date(Date.UTC(j, m - 1, 1)).getUTCDay() + 6) % 7;
      const tageImMonat = new Date(Date.UTC(j, m, 0)).getUTCDate();
      const kannZurueck = s.monat > d.heute.slice(0, 7);
      const kannVor = s.monat < d.bis.slice(0, 7);

      let zellen = '';
      for (let i = 0; i < ersterWt; i++) zellen += '<span class="tb-tag tb-tag--leer"></span>';
      for (let t = 1; t <= tageImMonat; t++) {
        const datum = s.monat + '-' + String(t).padStart(2, '0');
        const frei = !!d.tage[datum];
        const klassen = ['tb-tag'];
        if (frei) klassen.push('tb-tag--frei');
        if (datum === s.tag) klassen.push('tb-tag--gewaehlt');
        if (datum === d.heute) klassen.push('tb-tag--heute');
        zellen += frei
          ? '<button type="button" class="' + klassen.join(' ') + '" data-aktion="tag" data-wert="' + datum + '" aria-label="' + esc(datumLang(datum, true)) + '"' + (datum === s.tag ? ' aria-pressed="true"' : '') + '>' + t + '</button>'
          : '<span class="' + klassen.join(' ') + '" aria-hidden="true">' + t + '</span>';
      }

      return (
        '<div class="tb-kalender">' +
        '<div class="tb-monat">' +
        '<button type="button" class="tb-monat-btn" data-aktion="monat" data-wert="-1" aria-label="Vorheriger Monat"' + (kannZurueck ? '' : ' disabled') + '>' + ICON.links + '</button>' +
        '<span class="tb-monat-name">' + MONATE[m - 1] + ' ' + j + '</span>' +
        '<button type="button" class="tb-monat-btn" data-aktion="monat" data-wert="1" aria-label="Nächster Monat"' + (kannVor ? '' : ' disabled') + '>' + ICON.rechts + '</button>' +
        '</div>' +
        '<div class="tb-wochenkopf">' + KOPF.map((k) => '<span>' + k + '</span>').join('') + '</div>' +
        '<div class="tb-tage">' + zellen + '</div>' +
        '<p class="tb-zeitzone">' + ICON.welt + 'Mitteleuropäische Zeit</p>' +
        '</div>'
      );
    }

    function zeiten() {
      if (!s.tag || !s.daten || !s.daten.tage[s.tag]) return '';
      return (
        '<div class="tb-zeiten">' +
        '<p class="tb-zeiten-kopf">' + esc(datumLang(s.tag)) + '</p>' +
        '<div class="tb-zeiten-liste">' +
        s.daten.tage[s.tag].map((z) =>
          z === s.zeit
            ? '<div class="tb-zeit-paar"><span class="tb-zeit tb-zeit--gewaehlt">' + z + '</span>' +
              '<button type="button" class="tb-weiter" data-aktion="weiter">Weiter</button></div>'
            : '<button type="button" class="tb-zeit" data-aktion="zeit" data-wert="' + z + '">' + z + '</button>'
        ).join('') +
        '</div></div>'
      );
    }

    function ansichtZeit() {
      return (
        '<div class="tb-karte tb-karte--zwei' + (s.tag ? ' tb-karte--mit-zeiten' : '') + '">' +
        seite(false) +
        '<div class="tb-haupt">' +
        '<h3 class="tb-schritt">Tag und Uhrzeit wählen</h3>' +
        fehlerBox() +
        '<div class="tb-auswahl">' + kalender() + zeiten() + '</div>' +
        '</div></div>'
      );
    }

    function feld(name, label, typ, pflicht, extra) {
      const wert = esc(s.eingaben[name] || '');
      const id = 'tb-' + name;
      const eingabe = typ === 'textarea'
        ? '<textarea id="' + id + '" name="' + name + '" rows="' + ((extra && extra.zeilen) || 3) + '"' + (pflicht ? ' required' : '') + '>' + wert + '</textarea>'
        : '<input id="' + id + '" name="' + name + '" type="' + typ + '" value="' + wert + '"' + (pflicht ? ' required' : '') +
          (extra && extra.auto ? ' autocomplete="' + extra.auto + '"' : '') + '>';
      return '<div class="tb-feld"><label for="' + id + '">' + esc(label) + (pflicht ? ' *' : '') + '</label>' + eingabe + '</div>';
    }

    function wahl(name, optionen) {
      return (
        '<div class="tb-wahl" role="radiogroup">' +
        optionen.map(([wert, text]) =>
          '<label class="tb-wahl-option"><input type="radio" name="' + name + '" value="' + wert + '"' +
          (s.eingaben[name] === wert ? ' checked' : '') + '><span>' + esc(text) + '</span></label>'
        ).join('') +
        '</div>'
      );
    }

    function ansichtForm() {
      const tel = s.art === 'telefon';
      return (
        '<div class="tb-karte tb-karte--zwei">' +
        seite(true) +
        '<div class="tb-haupt">' +
        '<h3 class="tb-schritt">Ihre Angaben</h3>' +
        fehlerBox() +
        '<form class="tb-form" novalidate>' +
        (tel
          ? '<div class="tb-feld"><span class="tb-label">Wie möchten Sie sprechen? *</span>' +
            wahl('kanal', [['telefon', 'Telefonat'], ['video', 'Videokonferenz (Google Meet)']]) + '</div>'
          : '<div class="tb-feld"><span class="tb-label">Wo findet der Termin statt? *</span>' +
            wahl('ort', [['kunde', 'Bei mir vor Ort'], ['buero', 'In Ihrem Büro']]) + '</div>' +
            (s.eingaben.ort === 'kunde' ? feld('adresse', 'Adresse (Straße, PLZ, Ort)', 'textarea', true, { zeilen: 2 }) : '')) +
        feld('name', 'Name', 'text', true, { auto: 'name' }) +
        feld('email', 'E-Mail', 'email', true, { auto: 'email' }) +
        feld('telefon', 'Telefon', 'tel', true, { auto: 'tel' }) +
        feld('nachricht', 'Worum geht es? (optional)', 'textarea', false, { zeilen: 4 }) +
        '<div class="tb-falle" aria-hidden="true"><label>Website<input name="website" tabindex="-1" autocomplete="off"></label></div>' +
        '<p class="tb-datenschutz">Ihre Angaben verwenden wir nur zur Vereinbarung und Durchführung des Termins. ' +
        'Mehr dazu in unserer <a href="' + esc(datenschutz) + '" target="_blank" rel="noopener">Datenschutzerklärung</a>.</p>' +
        '<button type="submit" class="tb-buchen"' + (s.senden ? ' disabled' : '') + '>' + (s.senden ? 'Wird gebucht …' : 'Termin buchen') + '</button>' +
        '</form></div></div>'
      );
    }

    function ansichtFertig() {
      const t = s.ergebnis;
      const a = ARTEN[t.art];
      return (
        '<div class="tb-karte tb-karte--fertig">' +
        '<span class="tb-fertig-icon">' + ICON.haken + '</span>' +
        '<h2 class="tb-titel">Ihr Termin ist gebucht</h2>' +
        '<p class="tb-beschreibung">Eine Bestätigung haben wir an <strong>' + esc(t.email) + '</strong> gesendet.</p>' +
        '<ul class="tb-meta tb-meta--mitte">' +
        '<li>' + a.icon + esc(a.titel) + '</li>' +
        '<li>' + ICON.kalender + esc(t.zeit + ' – ' + t.bis + ', ' + datumLang(t.datum, true)) + '</li>' +
        '</ul></div>'
      );
    }

    function render() {
      const ansicht = { art: ansichtArt, zeit: ansichtZeit, form: ansichtForm, fertig: ansichtFertig }[s.schritt];
      root.innerHTML = ansicht();
    }

    // --- Ereignisse ---

    root.addEventListener('click', (ev) => {
      const el = ev.target.closest('[data-aktion]');
      if (!el || !root.contains(el)) return;
      const wert = el.getAttribute('data-wert');
      switch (el.getAttribute('data-aktion')) {
        case 'art':
          waehleArt(wert);
          break;
        case 'zurueck':
          gehe(s.schritt === 'form' ? 'zeit' : 'art');
          break;
        case 'monat':
          s.monat = monatPlus(s.monat, Number(wert));
          render();
          break;
        case 'tag':
          s.tag = wert;
          s.zeit = null;
          render();
          break;
        case 'zeit':
          s.zeit = wert;
          render();
          break;
        case 'weiter':
          gehe('form');
          break;
      }
    });

    root.addEventListener('input', (ev) => {
      if (ev.target.name) s.eingaben[ev.target.name] = ev.target.value;
    });

    root.addEventListener('change', (ev) => {
      if (ev.target.type === 'radio') {
        s.eingaben[ev.target.name] = ev.target.value;
        if (ev.target.name === 'ort') render();
      }
    });

    root.addEventListener('submit', (ev) => {
      ev.preventDefault();
      const form = ev.target;
      if (!form.reportValidity()) return;
      s.senden = true;
      s.fehler = '';
      render();
      const e = s.eingaben;
      api.post({
        action: 'buchen',
        art: s.art,
        datum: s.tag,
        zeit: s.zeit,
        name: e.name,
        email: e.email,
        telefon: e.telefon,
        nachricht: e.nachricht,
        kanal: e.kanal,
        ort: e.ort,
        adresse: e.adresse,
        website: e.website,
      }).then((d) => {
        s.senden = false;
        if (d.ok) {
          s.ergebnis = d.termin;
          gehe('fertig');
          return;
        }
        if (/nicht mehr frei/.test(d.fehler || '')) {
          // Platz inzwischen vergeben: Kalender neu laden und zurück zur Auswahl
          const art = s.art;
          ladeSlots(art);
          waehleArt(art);
          s.fehler = d.fehler;
          render();
          return;
        }
        s.fehler = d.fehler;
        render();
      });
    });

    const direkt = params.get('art');
    if (ARTEN[direkt]) waehleArt(direkt);
    else render();
  }

  // ---------- Absage ----------

  function absage(root, api, token) {
    const neuUrl = location.pathname;
    const zeige = (inhalt) => {
      root.innerHTML = '<div class="tb-karte tb-karte--fertig">' + inhalt + '</div>';
    };
    const terminListe = (t) =>
      '<ul class="tb-meta tb-meta--mitte">' +
      '<li>' + ARTEN[t.art].icon + esc(ARTEN[t.art].titel) + '</li>' +
      '<li>' + ICON.kalender + esc(t.zeit + (t.bis ? ' – ' + t.bis : '') + ', ' + datumLang(t.datum, true)) + '</li>' +
      '</ul>';
    const neuLink = '<p><a class="tb-link" href="' + esc(neuUrl) + '">Neuen Termin buchen</a></p>';

    zeige('<div class="tb-laden" role="status"><span class="tb-spinner"></span>Termin wird geladen …</div>');
    api.get({ action: 'absageinfo', token }).then((d) => {
      if (!d.ok) {
        zeige('<h2 class="tb-titel">Absage nicht möglich</h2><p class="tb-beschreibung">' + esc(d.fehler) + '</p>' + neuLink);
        return;
      }
      if (d.vorbei) {
        zeige('<h2 class="tb-titel">Termin liegt in der Vergangenheit</h2>' + terminListe(d.termin) + neuLink);
        return;
      }
      zeige(
        '<h2 class="tb-titel">Termin absagen?</h2>' +
        '<p class="tb-beschreibung">Guten Tag ' + esc(d.termin.name) + ', möchten Sie diesen Termin absagen?</p>' +
        terminListe(d.termin) +
        '<button type="button" class="tb-buchen tb-buchen--absage" data-absagen>Termin absagen</button>'
      );
      root.querySelector('[data-absagen]').addEventListener('click', (ev) => {
        ev.target.disabled = true;
        ev.target.textContent = 'Wird abgesagt …';
        api.post({ action: 'absagen', token }).then((r) => {
          zeige(r.ok
            ? '<span class="tb-fertig-icon">' + ICON.haken + '</span><h2 class="tb-titel">Ihr Termin ist abgesagt</h2>' +
              '<p class="tb-beschreibung">Sie erhalten eine Bestätigung per E-Mail.</p>' + neuLink
            : '<h2 class="tb-titel">Absage nicht möglich</h2><p class="tb-beschreibung">' + esc(r.fehler) + '</p>' + neuLink);
        });
      });
    });
  }

  function start() {
    document.querySelectorAll('[data-terminbuchung]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
